module.exports = __webpack_public_path__ + "img/info_banner2.c585d9b.jpg";